import React from 'react';
    import { motion } from 'framer-motion';

    const Hero = () => {
      const externalLink = "https://members.sellersanonymous.org/";
      // Converting the Vimeo link to the embeddable player format
      const videoUrl = "https://player.vimeo.com/video/1193484899";
      
      const scrollToMeetings = (e) => {
        e.preventDefault();
        const meetingsSection = document.getElementById('meetings');
        if (meetingsSection) {
          meetingsSection.scrollIntoView({ behavior: 'smooth' });
        }
      };

      return (
        <section className="py-20 lg:py-32 bg-gradient-to-br from-slate-50 via-white to-cyan-50">
          <div className="container">
            <div className="max-w-4xl mx-auto text-center">
              <motion.h1 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ delay: 0.1 }} 
                className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-800 mb-8 leading-tight"
              >
                Are you a <span className="text-cyan-600">buyer-centric seller</span> keen to break from a seller-centric world?
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
                className="mb-12 rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-slate-200 aspect-video w-full max-w-3xl mx-auto"
              >
                <iframe
                  src={videoUrl}
                  className="w-full h-full"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title="Sellers Anonymous Introduction"
                  frameBorder="0"
                ></iframe>
              </motion.div>

              <motion.p 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ delay: 0.3 }} 
                className="text-xl md:text-2xl text-slate-600 mb-8 leading-relaxed max-w-3xl mx-auto"
              >
                Sellers Anonymous is a community of people who sell and who put buyers first, the sale second—and who achieve exceptional results (or are keen to do so) by acting with integrity and the principles of{' '}
                <a href="https://thesellercode.org/" target="_blank" rel="noopener noreferrer" className="text-cyan-600 hover:text-cyan-700 underline">
                  The Seller Code
                </a>.
              </motion.p>

              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ delay: 0.4 }} 
                className="mb-10"
              >
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-slate-200 max-w-2xl mx-auto text-left">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">This is for you if:</h3>
                  <ul className="space-y-3 text-slate-600">
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2.5 flex-shrink-0"></div>
                      <span>You're good at selling, but hate "winning at all costs"</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2.5 flex-shrink-0"></div>
                      <span>You're buyer-centric by instinct, penalised by process</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2.5 flex-shrink-0"></div>
                      <span>You hit quota, but don't feel like a winner</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2.5 flex-shrink-0"></div>
                      <span>'Selling' isn't working for you. You just feel there must be a better way</span>
                    </li>
                  </ul>
                </div>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ delay: 0.5 }} 
                className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6"
              >
                <a 
                  href={externalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-200 hover:shadow-xl hover:scale-105 w-full sm:w-auto"
                >
                  Join a Meeting
                </a>
                <button 
                  onClick={scrollToMeetings}
                  className="text-cyan-600 hover:text-cyan-700 font-medium underline underline-offset-4"
                >
                  Not ready yet? What happens in a meeting ↓
                </button>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default Hero;